import { render, staticRenderFns } from "./bannerNameCell.vue?vue&type=template&id=24b1548c&scoped=true"
import script from "./bannerNameCell.vue?vue&type=script&lang=js"
export * from "./bannerNameCell.vue?vue&type=script&lang=js"
import style0 from "./bannerNameCell.vue?vue&type=style&index=0&id=24b1548c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b1548c",
  null
  
)

export default component.exports